import React, { useMemo } from 'react';
import { TeaRenderOptionsContext } from './context/TeaRenderOptionsContext';
import { useRenderChildren } from './hooks/useRenderChildren';
export var Previewer = React.memo(function (props) {
    var options = useMemo(function () { return ({ hasWrapper: false }); }, []);
    var el = useRenderChildren(options);
    return (React.createElement(TeaRenderOptionsContext.Provider, { value: options },
        React.createElement("div", { className: "saucer-editor-previewer", style: props.style }, el)));
});
Previewer.displayName = 'Previewer';
